export const providerSelectList = [
  {
    id: 1,
    title: "Nhà cung cấp",
    value: "name",
  },
  {
    id: 2,
    title: "Mã số thuê",
    value: "taxCode",
  },
  {
    id: 3,
    title: "SĐT nhà cung cấp",
    value: "phone",
  },
];
